:host {
}

.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.footer {
  display: flex;
  justify-content: center;
}

.footer .klevu-pagination {
  padding: var(--klevu-spacing-03) 0;
}
